import { Component, OnInit } from '@angular/core';
import { CustomerPendingApprovalService } from '../../../services/customer-pending-approval.service';
import { CustomerPendingApproval } from '../../../models/customer-pending-approval.model';
import { CommonModule, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { PaginatorModule } from 'primeng/paginator';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ViewCustomerPendingApprovalModalComponent } from './view-customer-pending-approval-modal/view-customer-pending-approval-modal.component';

@Component({
  selector: 'app-list-customer-pending-approval',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    FormsModule,
    InputTextModule,
    TooltipModule,
    PaginatorModule,
    ViewCustomerPendingApprovalModalComponent,
    DatePipe
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './list-customer-pending-approval.component.html'
})
export class ListCustomerPendingApprovalComponent implements OnInit {

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  customers: CustomerPendingApproval[] = [];
  searchTerm = '';
  loading = true;
  
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  currentPage: number = 1;

  showViewModal = false;
  selectedCustomer: CustomerPendingApproval | null = null;

  constructor(
    private customerPendingApprovalService: CustomerPendingApprovalService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      this.searchTerm = term;
      this.loadCustomers();
    });
  }

  ngOnInit(): void {
    this.loadCustomers();
  }

  onSearchChange() {
    this.searchSubject.next(this.searchTerm);
  }

  loadCustomers() {
    this.loading = true;
    this.customerPendingApprovalService.getAll(this.searchTerm, this.currentPage).subscribe({
      next: (data) => {
        console.log(data.data);
        this.customers = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar os registros'
        });
      }
    });
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadCustomers();
  }

  approve(customer: CustomerPendingApproval) {
    this.confirmationService.confirm({
      message: `Deseja realmente aprovar o cadastro de ${customer.customerFullName}?`,
      header: 'Confirmar Aprovação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.customerPendingApprovalService.approve(customer.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Cadastro aprovado com sucesso'
            });
            this.loadCustomers();
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao aprovar o cadastro'
            });
          }
        });
      }
    });
  }

  reject(customer: CustomerPendingApproval) {
    this.confirmationService.confirm({
      message: `Deseja realmente desaprovar o cadastro de ${customer.customerFullName}?`,
      header: 'Confirmar Desaprovação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.customerPendingApprovalService.reject(customer.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Cadastro desaprovado com sucesso'
            });
            this.loadCustomers();
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao desaprovar o cadastro'
            });
          }
        });
      }
    });
  }

  view(customer: CustomerPendingApproval) {
    this.selectedCustomer = customer;
    this.showViewModal = true;
  }

  onModalClosed() {
    this.showViewModal = false;
    this.selectedCustomer = null;
  }

  onApproved() {
    this.loadCustomers();
  }

  onRejected() {
    this.loadCustomers();
  }
}

